var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('b-card',[_vm._v("Lista de notificações")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }